<div class="" *ngIf="config.data.tipiPratica.length > 0">
    <div class="btn-group blocks col-sm-12 wrapper">
        <div class="row">
            <p class="col-xs-12 col-sm-4" calss="item" style="padding-left: 5px!important; padding-right: 5px!important;" *ngFor="let itemPratica of config.data.tipiPratica; let i = index">
                <a class="btn btn-primary" [ngClass]="'item-pratica-'+ itemPratica.endpoint"
                    routerLink="{{urladdPratica}}/{{itemPratica.endpoint}}"
                    data-dismiss="modal">{{itemPratica.descrizione}}</a>
            </p>
        </div>
    </div>
</div>
